import { Directive, ElementRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from './auth-service.service';

@Directive({
  selector: '[userHasClaim]'
})
export class HasClaimDirective {

  constructor(private authService: AuthService, private el: ElementRef, private viewContainer: ViewContainerRef) {}    
  @Input() set userHasClaim(claimName : string){            
      if(!this.authService.userHasClaim(claimName)){
          this.el.nativeElement.style.display = "none";
      }
  }

}
